import "./input.scss";
import PropTypes from "prop-types";
import React, { useState } from "react";
import ReactFlagsSelect, { In } from "react-flags-select";
import CountryFlagAndCode from "./CountryFlagAndCode";

const Input = ({
  min,
  max,
  type,
  name,
  value,
  label,
  error,
  touch,
  suffix, // %
  prefix, // ₹, Rs., +91, etc
  hintText,
  required,
  refForInput,
  disabled,
  leftIcon,
  fullWidth,
  rightIcon,
  errorOnly,
  autoFocus,
  customClass,
  placeholder,
  handleClick,
  handleChange,
  onIconClick,
  isNoKeyPress,
  autocomplete,
  // for edit action buttons
  prevValue,
  isEditButton,
  handleActionBtnClick,
  // for simple action button
  actionBtnText,
  // for country code with select
  isFlagSelect,
  country_code,
  seedCountries,
  handleCountrySelect,
  // for country code without select
  countryFlagImg,

  inputId,

  isInputFocussed,
  setFocusStateInParent,
  isUseParentStateForFocus,
}) => {
  const [isFocus, setIsFocus] = useState(false);
  const [showSuffix, setShowSuffix] = useState(true);
  const [isDisabled, setDisabled] = useState(true);

  value = type === "number" && value === 0 ? "" : value;
  const isInputFocus = isUseParentStateForFocus ? isInputFocussed : isFocus;

  const handleInputClick = () => {
    if (!disabled) {
      setShowSuffix(false);
      if (isUseParentStateForFocus) setFocusStateInParent(true);
      else setIsFocus(true);
    }
  };

  const handleInputLeave = () => {
    setShowSuffix(true);
    if (isUseParentStateForFocus) {
      // set out of focus when clicked on Done
      // setFocusStateInParent(false);
    } else setIsFocus(false);
  };

  const countriesCodeArr = seedCountries?.map((country) => country.code);
  const customLabelsObj = seedCountries?.reduce(
    (prev, curr) => ({
      ...prev,
      [curr.code]: curr.calling_code,
    }),
    {}
  );
  return (
    <div
      className={`sb-input${isInputFocus ? ` sb-input--focused` : ""}${
        (error && touch) || errorOnly ? ` sb-input--error` : ""
      }${customClass?.length > 0 ? ` ${customClass}` : ""}${
        fullWidth ? " sb-input--full-width" : ""
      }${
        disabled || (isDisabled && isEditButton) ? " sb-input--disabled" : ""
      }`}
    >
      {label && <label htmlFor={inputId || name || ""}>{label}</label>}

      <div
        className="input-parent"
        onClick={() => {
          if (showSuffix && (prefix || suffix)) handleInputClick();
        }}
      >
        <div className="input-row">
          {leftIcon ? (
            <>
              {typeof leftIcon === "string" ? (
                <img
                  width="20px"
                  height="20px"
                  src={leftIcon}
                  alt="textfield-icon"
                  className="input-icon"
                />
              ) : (
                leftIcon
              )}
            </>
          ) : (
            <></>
          )}

          {!isFlagSelect &&
            countryFlagImg?.length > 0 &&
            country_code?.length > 0 &&
            !leftIcon && (
              <CountryFlagAndCode flag={countryFlagImg} code={country_code} />
            )}

          {!countryFlagImg &&
            isFlagSelect &&
            countriesCodeArr?.length > 0 &&
            !leftIcon && (
              <ReactFlagsSelect
                optionsSize={12}
                showOptionLabel={true}
                selected={country_code}
                showSelectedLabel={true}
                onClick={handleInputClick}
                className="sb-country-select"
                countries={countriesCodeArr}
                customLabels={customLabelsObj}
                onSelect={(val) => handleCountrySelect(val)}
                selectButtonClassName="sb-country-select-button"
                placeholder={
                  <div>
                    <span style={{ fontSize: "16px" }}>
                      <In />
                    </span>{" "}
                    &nbsp; +91
                  </div>
                }
              />
            )}

          {showSuffix && (prefix || suffix) ? (
            <div className="prefix-value-suffix-row">
              {value ? (
                <>
                  <span>{prefix}</span>
                  <span className="filler">{value}</span>
                  <span>{suffix}</span>
                </>
              ) : (
                <span className="prefix-suffix-placeholder">{placeholder}</span>
              )}
            </div>
          ) : (
            <input
              min={min}
              max={max}
              name={name}
              value={value}
              required={required}
              type={type || "text"}
              onChange={handleChange}
              ref={refForInput}
              onBlur={handleInputLeave}
              onFocus={handleInputClick}
              id={inputId || name || ""}
              placeholder={placeholder || ""}
              onWheel={(e) => e.target.blur()}
              autoComplete={autocomplete || "off"}
              disabled={disabled || (isDisabled && isEditButton)}
              autoFocus={autoFocus || (!showSuffix && isInputFocus)}
              onClick={(e) => {
                if (handleClick) {
                  onIconClick;
                  e.stopPropagation();
                  handleClick(e);
                }
              }}
              onKeyDown={(e) =>
                isNoKeyPress
                  ? {}
                  : e.key === "Enter" && onIconClick && onIconClick()
              }
            />
          )}

          {/* for icon buttons */}
          {(value?.length > 0 || (typeof value === "number" && value > 0)) &&
            rightIcon &&
            (typeof rightIcon === "string" ? (
              <img
                width="16px"
                height="16px"
                src={rightIcon}
                alt="textfield-icon"
                onClick={onIconClick}
                className="input-icon"
              />
            ) : (
              rightIcon
            ))}

          {/* for edit and save action button */}
          {!rightIcon &&
            isEditButton &&
            (isDisabled ? (
              <span className="edit-btn" onClick={() => setDisabled(false)}>
                Edit
              </span>
            ) : prevValue !== value ? (
              <span className="edit-btn" onClick={handleActionBtnClick}>
                Save
              </span>
            ) : (
              <></>
            ))}

          {/* for simple action button */}
          {!rightIcon &&
            !isEditButton &&
            value?.length > 0 &&
            actionBtnText?.length > 0 && (
              <span className="edit-btn" onClick={handleActionBtnClick}>
                {actionBtnText}
              </span>
            )}
        </div>
      </div>

      {errorOnly && typeof errorOnly === "string" && errorOnly?.length > 0 ? (
        <p className="error-text">{errorOnly}</p>
      ) : error && error?.length > 0 && touch ? (
        <p className="error-text">{error}</p>
      ) : hintText && hintText?.length > 0 ? (
        <p className="hint-text">{hintText}</p>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Input;

Input.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  touch: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  suffix: PropTypes.string, // %
  prefix: PropTypes.string, // ₹, Rs., +91, etc
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  autoFocus: PropTypes.bool,
  inputId: PropTypes.string,
  hintText: PropTypes.string,
  handleClick: PropTypes.func,
  onIconClick: PropTypes.func,
  handleChange: PropTypes.func,
  isNoKeyPress: PropTypes.bool,
  isEditButton: PropTypes.bool,
  customClass: PropTypes.string,
  placeholder: PropTypes.string,
  autocomplete: PropTypes.string,
  countryFlagImg: PropTypes.string,
  leftIcon: PropTypes.node || PropTypes.string,
  rightIcon: PropTypes.node || PropTypes.string,

  // for action buttons
  prevValue: PropTypes.string,
  actionBtnText: PropTypes.string,
  handleActionBtnClick: PropTypes.func,

  isFlagSelect: PropTypes.bool,
  country_code: PropTypes.string,
  seedCountries: PropTypes.array,
  handleCountrySelect: PropTypes.func,

  value: PropTypes.any,
  type: PropTypes.oneOf([
    "email",
    "text",
    "password",
    "number",
    "search",
    "tel",
    "url",
  ]),

  isInputFocussed: PropTypes.bool,
  setFocusStateInParent: PropTypes.func,
  isUseParentStateForFocus: PropTypes.bool,
};

Input.defaultProps = {
  type: "text",
  disabled: false,
  autoFocus: false,
  fullWidth: false,
  isNoKeyPress: true,
  autocomplete: "off",
  isEditButton: false,
  isFlagSelect: false,
};
